import React, { useEffect, useState, useContext, useRef } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import Confetti from 'react-dom-confetti';
import classNames from 'clsx';
import Paper from '@material-ui/core/Paper';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';

import { FormsEnum } from 'app/shared/enums';
import { CompactModal } from 'app/components/CompactModal';
import { MubiInstallmentsContext } from 'app/components/MubiInstallmentsRadioOption/useMubiInstallments.context';
import {
  mubiInstallmentsModalConfig,
  animationConfig,
} from './mubiInstallmentsModalConfig';
import { useStyles } from './MubiInstallmentsModal.styles';

const stepTitle = new Map<number, string>([
  [0, '1. Wniosek'],
  [1, '2. Decyzja'],
  [2, '3. Umowa'],
]);

function MubiInstallmentsModal() {
  const [animationActive, setAnimationActive] = useState<boolean>(false);
  const classes = useStyles();

  const {
    setIsRejected,
    setHiProInstalmentContractConfirmed,
    closeModal,
    activeStep,
    setActiveStep,
  } = useContext(MubiInstallmentsContext);
  const dispatch = useDispatch();

  const scrollModal = useRef<Scrollbars | null>(null);

  useEffect(() => {
    if (activeStep < 2) setActiveStep(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (scrollModal.current) {
      scrollModal.current?.scrollToTop();
    }
  }, [activeStep]);

  useEffect(() => {
    if (activeStep === 6) {
      setTimeout(() => {
        setAnimationActive(true);
      }, 100);
    }
    return () => {
      setAnimationActive(false);
    };
  }, [activeStep]);

  const currentConfig = mubiInstallmentsModalConfig[activeStep];
  const ContentElement = currentConfig.content;

  const handleOnCloseModal = () => {
    if (activeStep === 7) {
      setIsRejected(true);
      dispatch(change(FormsEnum.CheckoutPaymentForm, 'payment', {}));
    }
    if (activeStep === 6) {
      setHiProInstalmentContractConfirmed(true);
    }

    closeModal(currentConfig.closeNameEvent);
  };

  return (
    <CompactModal
      onClose={handleOnCloseModal}
      className={classNames(classes.modal, {
        [classes.greyBackground]: currentConfig.greyBackground,
      })}
    >
      {currentConfig.progressBar && (
        <div className={classes.indicatorRoot}>
          <div className={classes.indicatorTitle}>
            {currentConfig.progressBar?.title}
          </div>
          <Paper square elevation={0} className={classes.indicatorContainer}>
            <div className={classes.indicatorWrapper}>
              <div className={classes.indicator}>
                {[0, 1, 2].map((step) => (
                  <div
                    key={step}
                    className={classNames(classes.step, {
                      [classes.stepActive]:
                        currentConfig.progressBar.state >= step,
                    })}
                  >
                    <p
                      className={classNames(classes.stepTitle, {
                        [classes.stepTitleActive]:
                          currentConfig.progressBar.state >= step,
                      })}
                    >
                      {stepTitle.get(step)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </Paper>
        </div>
      )}
      <Scrollbars
        autoHeight
        autoHeightMin={0}
        autoHeightMax={'65vh'}
        id="mubi-installments-scrollbars"
        marginHeight={0}
        ref={scrollModal}
      >
        <div className={classes.contentContainer}>
          <ContentElement />
        </div>
      </Scrollbars>
      <div className={classes.animationContainer}>
        <Confetti active={animationActive} config={animationConfig} />
      </div>
    </CompactModal>
  );
}

export default MubiInstallmentsModal;
